<template>
  <div class="chk">
    <template v-for="grupo in grupos">
      <!-- Conteúdo injetado imediatamente antes do grupo "Enquadramento e Parecer Jurídico" (ex.: campos do parecer jurídico) -->
      <slot v-if="grupo.titulo === 'Enquadramento e Parecer Jurídico'" name="antes-enquadramento"></slot>
      <section :key="grupo.titulo" class="chk-secao">
      <div class="chk-titulo">{{ grupo.titulo }}</div>
      <!-- Conteúdo injetado no topo do grupo "Regularidade da Proposta e da Proponente" (ex.: ocorrências impeditivas) -->
      <slot v-if="grupo.titulo === 'Regularidade da Proposta e da Proponente'" name="inicio-regularidade"></slot>

      <div class="chk-card">
        <template v-for="item in grupo.itens">
          <!-- Pergunta de texto livre: rótulo em cima, campo em largura total -->
          <div
            v-if="item.texto"
            :key="item.chave"
            class="chk-row chk-row--texto"
            :class="{ 'chk-row--ok': respondido(item.chave) }"
          >
            <label class="chk-q">{{ item.pergunta }}</label>
            <input
              type="text"
              class="chk-input"
              maxlength="255"
              :disabled="disabled"
              :value="dados[item.chave]"
              @input="atualiza(item.chave, $event.target.value)">
          </div>

          <!-- Pergunta Sim/Não/N/A: pergunta à esquerda, controle segmentado à direita -->
          <div
            v-else
            :key="item.chave"
            class="chk-row"
            :class="{ 'chk-row--ok': respondido(item.chave) }"
          >
            <span class="chk-q">{{ item.pergunta }}</span>
            <div class="chk-seg" role="group">
              <button
                v-for="opcao in opcoes"
                :key="opcao"
                type="button"
                class="chk-seg-btn"
                :class="classeOpcao(item.chave, opcao)"
                :disabled="disabled"
                @click="alterna(item.chave, opcao)"
              >{{ opcao }}</button>
            </div>
          </div>
        </template>

        <!-- Observação da seção (largura total, dentro do mesmo cartão) -->
        <div
          v-if="grupo.observacaoChave"
          class="chk-row chk-row--texto"
          :class="{ 'chk-row--ok': respondido(grupo.observacaoChave) }"
        >
          <label class="chk-q">Observações</label>
          <textarea
            class="chk-input"
            rows="3"
            :disabled="disabled"
            :value="dados[grupo.observacaoChave]"
            @input="atualiza(grupo.observacaoChave, $event.target.value)"></textarea>
        </div>
      </div>
      </section>
    </template>
  </div>
</template>

<script>
  import { GRUPOS_CHECKLIST_ANALISE, OPCOES_SIM_NAO } from '../../mixins/checklistAnalise'

  /**
   * Checklist da Análise: perguntas Sim/Não migradas da antiga tela de
   * Relatório de Análise, mantendo os agrupamentos temáticos originais.
   * Cada resposta é gravada com chave própria na estrutura chave-valor
   * da proposta (analise.dados -> tb_proposta_dado).
   */
  export default {
    name: 'checklistAnalise',
    props: {
      // Objeto reativo analise.dados (mapa chave => valor)
      dados: {
        type: Object,
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        grupos: GRUPOS_CHECKLIST_ANALISE,
        opcoes: OPCOES_SIM_NAO
      }
    },
    methods: {
      respondido (chave) {
        let valor = this.dados[chave]
        return valor !== null && valor !== undefined && valor !== ''
      },
      classeOpcao (chave, opcao) {
        if (this.dados[chave] !== opcao) {
          return ''
        }
        // N/A selecionado usa cinza médio; Sim/Não usam a cor primária
        return opcao === 'N/A' ? 'chk-seg-btn--na' : 'chk-seg-btn--sel'
      },
      atualiza (chave, valor) {
        this.$set(this.dados, chave, valor)
      },
      // Clicar de novo na opção já selecionada desmarca a resposta
      alterna (chave, opcao) {
        this.atualiza(chave, this.dados[chave] === opcao ? '' : opcao)
      }
    }
  }
</script>

<style scoped>
  .chk-secao {
    margin-bottom: 18px;
  }
  .chk-titulo {
    font-weight: bold;
    font-size: 15px;
    color: #444;
    margin-bottom: 8px;
  }
  .chk-card {
    border: 1px solid #d2d6de;
    overflow: hidden;
    background: #fff;
  }
  .chk-row {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 16px;
    align-items: center;
    padding: 10px 14px;
    border-top: 1px solid #f2f2f2;
    transition: background-color .15s ease;
  }
  .chk-row:first-child {
    border-top: 0;
  }
  .chk-row--ok {
    background: rgba(60, 141, 188, .06);
  }
  .chk-row--texto {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  .chk-q {
    font-size: 14px;
    color: #333;
    line-height: 1.35;
    margin: 0;
    font-weight: normal;
  }
  .chk-input {
    width: 100%;
    border: 1px solid #d2d6de;
    padding: 6px 10px;
    font-size: 14px;
    color: #333;
    resize: vertical;
  }
  .chk-input:focus {
    border-color: #3c8dbc;
    outline: 0;
  }
  /* Controle segmentado: 3 botões colados com divisores internos de 1px */
  .chk-seg {
    display: inline-flex;
    border: 1px solid #d2d6de;
    overflow: hidden;
    white-space: nowrap;
  }
  .chk-seg-btn {
    border: 0;
    border-left: 1px solid #d2d6de;
    background: #fff;
    color: #767676;
    font-size: 14px;
    line-height: 1.2;
    padding: 5px 16px;
    cursor: pointer;
    transition: background-color .12s ease, color .12s ease;
  }
  .chk-seg-btn:first-child {
    border-left: 0;
  }
  .chk-seg-btn:disabled {
    cursor: not-allowed;
    opacity: .65;
  }
  .chk-seg-btn--sel {
    background: #3c8dbc;
    color: #fff;
  }
  .chk-seg-btn--na {
    background: #6c757d;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// checklistAnalise.vue?4b97d208